/* eslint-disable react/prop-types */
import React from 'react';
import { CheckboxStyled, TextStyled } from '@nike/nike-design-system-components';
import { Tooltip } from '@nike/eds';

import { Currency, Icon } from '../../components';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import ColumnFilterSort from '../../components/table/tableClientSide/ColumnFilterSort';

import { ZERO_DOLLAR_VALUE } from '../../util/constants';
import { mapSilhouette } from '~APP_UTIL/silhouettes';
import { GA_EVENT_ALLOTMENTS_ALLOW_BILLABLE_CLICK, sendEventToGA } from '../../analytics/constants';

export const getAllotmentColumns = ({
  isAllowedBillable,
  handleCheckBillable,
  handleCheckAllBillable,
  selectedBillableDepts,
  selectAllChecked
}) => [
  {
    Header: ({ column }) => (
      <ColumnFilterSort
        header={new TranslatedCopy({ id: 'alloments.table.department.title' }).toString()}
        column={column}
        align='right'
      />
    ),
    accessor: 'departmentName'
  },
  {
    Header: ({ column }) => (
      <ColumnFilterSort
        header={new TranslatedCopy({ id: 'allotments.table.allocated.title' }).toString()}
        column={column}
        align='right'
      />
    ),
    accessor: 'allotment',
    Cell: ({ row }) => <Currency value={row.original.allotment} type={row.original.currencyCode} />
  },
  {
    Header: ({ column }) => (
      <ColumnFilterSort
        header={new TranslatedCopy({ id: 'global.remainingBalance' }).toString()}
        column={column}
        align='right'
      />
    ),
    accessor: 'remainingAllotment',
    Cell: ({ row }) => (
      <Currency
        value={row.original.remainingAllotment}
        type={row.original.currencyCode}
        error={row.original.remainingAllotment && parseFloat(row.original.remainingAllotment) < 0}
      />
    )
  },
  {
    Header: ({ column }) => (
      <ColumnFilterSort
        header={new TranslatedCopy({ id: 'global.unitAllotment' }).toString()}
        column={column}
        align='right'
      />
    ),
    accessor: 'unitAllotments',
    sortType: (rowA, rowB) => {
      if (rowA.original.unitAllotments.length < rowB.original.unitAllotments.length) {
        return -1;
      }
      return 1;
    },
    Cell: ({ value }) =>
      value.length ? (
        <Tooltip
          id='unitAllotmentsTooltip'
          bodySlot={
            <div css={{ lineHeight: 'initial' }}>
              {value.map(unitAllt => (
                <div>
                  <TextStyled appearance='body3' bold>
                    <TranslatedCopy
                      id='allotments.sidebar.details.unit.details'
                      values={{ amount: unitAllt.allotmentAmount, description: mapSilhouette(unitAllt) }}
                    />
                  </TextStyled>
                  <TextStyled appearance='body3' style={{ paddingLeft: '10px' }}>
                    <TranslatedCopy
                      id='allotments.sidebar.details.unit.remaining'
                      values={{ amount: parseInt(unitAllt.allotmentAmount, 10) - parseInt(unitAllt.totalSpend, 10) }}
                    />
                  </TextStyled>
                </div>
              ))}
            </div>
          }
          isDark
          enableFocus
        >
          <div className='swap-on-highlighted'>
            <Icon name='box' alt='unit allotment' />
            <Icon name='box' alt='unit allotment' isLight />
          </div>
        </Tooltip>
      ) : null
  },
  {
    Header: ({ column }) => (
      <ColumnFilterSort
        header={new TranslatedCopy({ id: 'alloments.table.locked.title' }).toString()}
        column={column}
        align='right'
      />
    ),
    accessor: 'lockedAllotment',
    Cell: ({ value }) =>
      value && value !== ZERO_DOLLAR_VALUE ? (
        <div
          className='swap-on-highlighted'
          title={new TranslatedCopy({ id: 'allotments.sidebar.details.locked.title' }).toString()}
        >
          <Icon name='filled-lock' alt='purchase options' />
          <Icon name='filled-lock' alt='purchase options' isLight />
        </div>
      ) : null
  },
  ...(isAllowedBillable
    ? [
        {
          Header: () => (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <TranslatedCopy id='department.card.billable' />
              <CheckboxStyled
                id='checkAllBillable'
                checked={selectAllChecked}
                onChange={e => handleCheckAllBillable(e.target.checked)}
              />
            </div>
          ),
          accessor: 'billable',
          Cell: ({ row }) => (
            <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
              <CheckboxStyled
                id='allowBillableOrders'
                checked={selectedBillableDepts[row.original.departmentNumber]}
                onChange={e => {
                  handleCheckBillable({ deptNumber: row.original.departmentNumber, checked: e.target.checked });

                  if (e.target.checked) {
                    sendEventToGA(GA_EVENT_ALLOTMENTS_ALLOW_BILLABLE_CLICK);
                  }
                }}
              />
            </div>
          )
        }
      ]
    : [])
];
